import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

// returns the current position of the device
export function getLocalPosition(errorMessages, apiKey) {
    return new Promise((resolve, reject) => {
        // we are getting the stored in the session storage location
        let localPosition = sessionStorage.getItem("localPosition");
        let usedProtocol = window.location.href.split("://")[0];

        if (localPosition) {
            // if there is a stored location object
            // in the session storage we resolve the promise
            resolve(JSON.parse(localPosition));
        } else {
            // The geo location of the navigator object supports only requests made from
            // secure origin or in other words https protocol.
            if (navigator.geolocation && usedProtocol === "https") {
                navigator.geolocation.getCurrentPosition(
                    function(position) {
                        let pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        sessionStorage.setItem("localPosition", JSON.stringify(pos));
                        resolve(pos);
                    },
                    function(status) {
                        WEBUILogs.error(errorMessages.geoLocationError);
                        reject(status);
                    }
                );
            } else {
                // If for some reason there is not support for a secure origin or in other words
                // the used protocol is http, a request to the google geo location api is been made.
                let request = new XMLHttpRequest();

                request.addEventListener(
                    "load",
                    function(response) {
                        let pos = JSON.parse(response.currentTarget.response).location;

                        sessionStorage.setItem("localPosition", JSON.stringify(pos));
                        resolve(pos);
                    },
                    function(status) {
                        WEBUILogs.error(errorMessages.geoLocationError);
                        reject(status);
                    }
                );

                request.open(
                    "POST",
                    `https://www.googleapis.com/geolocation/v1/geolocate?key=${apiKey}`
                );
                request.send();
            }
        }
    });
}
